import { Select, type SelectOption } from 'design-system/react';

import { TeamResponse } from '../../client';

interface Props {
  teams: TeamResponse[];
  onTeamSelected: (team: TeamResponse | null) => void;
}

export function TeamSelect({ teams, onTeamSelected }: Props) {
  const getTeamOrNull = (teamName: string) => {
    return teams.find((team) => team.name === teamName) || null;
  };

  const options: SelectOption[] = [
    { value: '', label: 'Select team' },
    ...teams.map((team) => ({ value: team.name, label: team.name })),
  ];

  return <Select options={options} defaultValue="" onChange={(value) => onTeamSelected(getTeamOrNull(value))} />;
}
